var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title)),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }